const colors = {
  black: "#000000",
  white: "#fff",
  grey: "#f7f7f7",
  cherryRed: "#B11116",
  red: "#d70202",
  error: "#DB0007",
  backgroundError: "#EDDBDB",
  coffeeBrown: "#45251C",
  paprika: "#A54C4C",
  wheat: "#DDD6C5",
  flour: "#F7F3EB",
  sand: "#BEB6A6",
  yellow: "#ffbc0d",
  darkYellow: "#ffb900",
  disabled: "#e5e5e5",
  blackOlive: "#281813",
  bazil: "#61A864",
  lightBackground: "#FEFEFD",
  darkGreen: "#264f36",
  whiteGlassFill: "rgba(254, 254, 253, 0.8)",
  flourGlassFill: "rgba(247, 243, 235, 0.8)",
  memberRedGold:
    "linear-gradient(90deg, #FFDDD2 0%, #FFF3EF 16.15%, #FFDDD2 48.96%, #FFF3EF 77.08%, #FFDDD2 100%)",
  memberRedGoldSolid: "#FFDDD2",
  marbleGrey: "#857878",
  darkGrey: "#504141",
  warmGray: "#757575",
  wheatOpacity: "rgba(221, 214, 197, 0.8)",
  flourOpacity: "rgba(247, 243, 235, 0.8)",
  transparent: "rgba(247,243,235,0)",
}

export default colors
